// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanToReactivate
 */
export interface IPlanToReactivate {
    /**
     * 
     * @type {number}
     * @memberof IPlanToReactivate
     */
    plan_id: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanToReactivate
     */
    external_bank_account_id?: number;
}

/**
 * Check if a given object implements the IPlanToReactivate interface.
 */
export function instanceOfIPlanToReactivate(value: object): value is IPlanToReactivate {
    if (!('plan_id' in value) || value['plan_id'] === undefined) return false;
    return true;
}

export function IPlanToReactivateFromJSON(json: any): IPlanToReactivate {
    return IPlanToReactivateFromJSONTyped(json, false);
}

export function IPlanToReactivateFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanToReactivate {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'],
        'external_bank_account_id': json['external_bank_account_id'] == null ? undefined : json['external_bank_account_id'],
    };
}

export function IPlanToReactivateToJSON(json: any): IPlanToReactivate {
    return IPlanToReactivateToJSONTyped(json, false);
}

export function IPlanToReactivateToJSONTyped(value?: IPlanToReactivate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'external_bank_account_id': value['external_bank_account_id'],
    };
}

